import React from 'react';
import * as styles from './CTA.module.scss';
import { formatParagraphs } from '@helpers';
import classNames from 'classnames';

export default function CTA({ items = [] }) {
  return !items?.length ? null : (
    <section
      className={classNames(styles.wrapper, {
        [styles.single]: items.length === 1
      })}
    >
      <div className={styles.content}>
        {items.map((item, index) => (
          <Item
            key={index}
            {...item}
          />
        ))}
      </div>
    </section>
  );
}

function Item({
  headline,
  text,
  buttonText,
  buttonUrl,
  buttonType = 'primary'
}) {
  const buttonTypeClassName =
    buttonType === 'outline' ? 'btn-outline-primary' : 'btn-primary';

  return !headline || !text || !buttonText || !buttonUrl ? null : (
    <div
      className={classNames(styles.item, {
        [styles.hasHeadline]: !!headline?.trim()
      })}
    >
      <div className={styles.text}>
        {headline && (
          <strong className={classNames('subheadline', styles.headline)}>
            {headline}
          </strong>
        )}
        {formatParagraphs(text)}
      </div>
      {buttonText && buttonUrl && (
        <div className={styles.buttonWrapper}>
          <a
            href={buttonUrl}
            className={classNames('btn', buttonTypeClassName)}
          >
            {buttonText}
          </a>
        </div>
      )}
    </div>
  );
}
